import React from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';

import Container from './styled/card-container';

interface IProps extends IBaseProps {
  isListView?: boolean;
}

export default function CardContainer({ children, isListView }: IProps) {
  return (
    <Container data-testid="store-locator-card-container" isListView={isListView}>
      {children}
    </Container>
  );
}
